import { Link } from 'react-router-dom'

import { formatInteger, LoadingBlock } from '@/design'
import { useFilterSearch } from '@/lib/useGlobalFilters'

import { useMarketQuery } from './hooks'

const TILES = [
  { key: 'newLaunches', label: 'New launches' },
  { key: 'closingSoon', label: 'Closing soon' },
  { key: 'priceChanges', label: 'Price changes' },
  { key: 'categoryTrends', label: 'Category trends' },
] as const

/** New launches, closing soon, price changes and category trends, in the selected period. */
export function ActivitySummaryStrip() {
  const summary = useMarketQuery('activity-summary', (client, filters) => client.marketActivitySummary(filters))
  const search = useFilterSearch()

  if (summary.isPending) return <LoadingBlock rows={1} />
  if (!summary.data) return null

  return (
    <ul className="mk-activity-strip">
      {TILES.map((tile) => (
        <li key={tile.key}>
          <Link to={{ pathname: '/market/activity', search }} className="mk-activity-strip__tile">
            <span className="mk-activity-strip__value">{formatInteger(summary.data.data[tile.key])}</span>
            <span className="mk-activity-strip__label">{tile.label}</span>
          </Link>
        </li>
      ))}
    </ul>
  )
}
